// Batch GET succeeds even when individual jobs failed. Preserve that typed
// history independently of the account's current billing/access snapshot.
export function batchWithJobs(response) {
  const payload = response?.data || response;
  const batch = payload?.batch || payload;
  return batch ? { ...batch, jobs: payload?.jobs || batch.jobs } : null;
}

export function generationFailureForItem(row, batch) {
  const item = row.contentItem || row;
  const job = Array.isArray(batch?.jobs) ? batch.jobs.find(job => job.contentItemId === item.id) : null;
  if (job) return {
    generationErrorCode: job.status === 'failed' ? job.errorCode || null : null,
    generationErrorMessage: job.status === 'failed' ? job.errorMessage || null : null,
  };
  return {
    generationErrorCode: row.generationErrorCode || row.jobErrorCode || null,
    generationErrorMessage: row.generationErrorMessage || row.jobErrorMessage || null,
  };
}

export function batchGenerationFailure(items) {
  const failures = items.filter(item => item.status === 'failed' || item.generationStatus === 'failed');
  const first = failures[0];
  // Mixed failures must not turn an unrelated provider failure into billing.
  const sameCode = first?.generationErrorCode && failures.every(item => item.generationErrorCode === first.generationErrorCode);
  return {
    errorCode: sameCode ? first.generationErrorCode : null,
    error: sameCode ? first.generationErrorMessage || 'Batch generation failed' : 'Batch generation failed',
  };
}
